import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getFactorListApi } from '~/features/factor/api/get-factor.api';

import type { Factor } from '~/features/factor/types/factor.type';

export interface FactorState {
  isLoading: boolean;
  list: Factor[];
}

const initialState: FactorState = {
  isLoading: false,
  list: [],
};

/**
 * Factor 목록 조회
 */
export const fetchFactorList = createAsyncThunk<Factor[]>(
  'factor/fetchList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await getFactorListApi();
      return data.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

const FactorSlice = createSlice({
  initialState,
  name: 'factor',
  reducers: {
    addFactor: (state, action) => {
      state.list.push(action.payload);
    },
    resetFactor: state => {
      state.list = [];
      state.isLoading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchFactorList.pending, state => {
        state.isLoading = true;
      })
      .addCase(fetchFactorList.fulfilled, (state, action) => {
        state.list = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchFactorList.rejected, state => {
        state.isLoading = false;
      });
  },
});

export const { addFactor, resetFactor } = FactorSlice.actions;
export default FactorSlice;
